<div class="flex-fill d-flex flex-column justify-content-center py-4">

  <div class="container-tight py-6">

    <div class="text-center mb-4">

      <svg height="100" viewBox="0 0 1024 691" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M278.944 196.997C260.938 199.044 240.725 199.757 219.411 198.831C205.349 198.219 191.828 196.937 179.148 195.101C150.167 192.187 123.387 186.205 107.884 174.474C96.0091 167.991 88.7159 160.681 87.5505 153.106C109.695 167.342 153.44 178.249 204.151 180.454C235.899 181.834 265.216 179.577 288.416 174.687C265.116 174.726 239.135 172.749 211.897 168.551C153.774 161.205 87.5711 143.548 54.1351 111.951C43.3276 102.949 37.1816 93.8069 36.9013 85.1343C64.0113 107.65 120.333 129.28 187.298 140.49C227.386 147.198 265.059 149.136 295.894 146.931C297.302 146.672 298.711 146.405 300.126 146.122C181.993 126.183 66.6919 112.519 0 0C122.18 92.8133 322.014 114.452 361.398 137.852C363.844 181.642 384.68 220.482 416.235 246.653C442.314 268.564 475.853 281.747 512.44 281.747C592.916 281.747 658.651 217.979 662.648 137.823C702.153 114.436 901.869 92.7743 1024 0C957.308 112.519 842.004 126.183 723.871 146.122C725.286 146.405 726.696 146.672 728.106 146.931C758.936 149.136 796.608 147.198 836.7 140.49C903.664 129.28 959.989 107.65 987.099 85.1343C986.816 93.8069 980.672 102.949 969.862 111.951C936.424 143.548 870.221 161.205 812.101 168.551C784.862 172.749 758.884 174.726 735.582 174.687C758.781 179.577 788.098 181.834 819.844 180.454C870.555 178.249 914.305 167.342 936.444 153.106C935.282 160.681 927.986 167.991 916.116 174.474C900.613 186.205 873.833 192.187 844.85 195.101C832.172 196.937 818.645 198.219 804.584 198.831C783.272 199.757 763.062 199.044 745.054 196.997C728.389 196.574 717.625 196.325 717.625 197.685C778.297 215.948 832.717 212.772 873.545 202.969C875.206 202.25 876.786 201.503 878.257 200.735C873.421 220.28 821.197 233.433 758.277 230.408C739.821 229.521 722.415 227.339 706.959 224.192C705.41 224.26 703.949 224.343 702.606 224.452L702.616 225.116C709.511 227.45 716.802 229.606 724.38 231.518C758.653 240.167 789.987 241.617 807.557 236.535C807.187 237.327 806.703 238.076 806.122 238.787L806.539 238.73C805.932 239.259 805.325 239.773 804.717 240.271C804.172 240.761 803.575 241.231 802.922 241.677C766.159 269.565 719.914 241.973 682.277 241.973C693.293 249.021 739.373 265.487 750.456 265.487C738.082 282.515 669.764 261.025 667.104 269.596C686.995 279.768 705.127 285.701 717.908 286.383C710.818 293.694 691.359 291.273 667.284 281.291C567.555 264.667 545.323 350.167 511.997 421.311C478.672 350.167 456.445 264.667 356.713 281.291C332.641 291.273 313.182 293.694 306.09 286.383C318.873 285.701 337.005 279.768 356.893 269.596C354.233 261.025 285.915 282.515 273.541 265.487C284.624 265.487 330.707 249.021 341.723 241.973C304.081 241.973 257.838 269.565 221.073 241.677C220.425 241.231 219.823 240.761 219.283 240.271C218.673 239.773 218.063 239.259 217.459 238.73L217.875 238.787C217.294 238.076 216.81 237.327 216.44 236.535C234.011 241.617 265.347 240.167 299.614 231.518C307.196 229.606 314.484 227.45 321.381 225.116L321.392 224.452C320.051 224.343 318.587 224.26 317.041 224.192C301.583 227.339 284.176 229.521 265.723 230.408C202.8 233.433 150.576 220.28 145.737 200.735C147.214 201.503 148.789 202.25 150.453 202.969C191.28 212.772 245.698 215.948 306.37 197.685C306.37 196.325 295.612 196.574 278.944 196.997Z" fill="#C0A062" />
        <path d="M879.59 657.4V483.889L943.761 484.142C958.954 484.142 971.179 488.796 980.43 498.099C989.682 507.408 994.307 519.708 994.307 534.996C994.307 547.959 990.546 559.136 983.029 568.527C975.517 577.918 966.472 582.696 955.903 582.862C958.543 585.021 960.941 587.433 963.086 590.089C969.199 597.901 982.988 620.338 1004.46 657.4H963.58C957.802 647.429 952.436 637.955 947.476 628.978C938.888 613.188 932.735 602.555 929.02 597.073C925.3 591.585 921.955 588.096 918.987 586.6C917.33 585.766 915.514 585.269 913.533 585.103V657.4H879.59ZM925.922 512.062H913.78L913.533 558.929H925.176C938.394 558.929 947.146 556.936 951.443 552.944C955.739 548.958 957.884 543.222 957.884 535.746C957.884 526.107 954.663 519.537 948.222 516.048C943.596 513.392 936.161 512.062 925.922 512.062Z" fill="#1A3233" />
        <path d="M581.777 569.894C581.777 607.623 570.298 634.212 547.34 649.671C549.156 650.002 554.523 652.911 563.444 658.399C571.044 663.048 578.062 665.378 584.503 665.378C589.129 665.378 594.248 664.963 599.867 664.13L590.698 686.815C586.896 688.808 581.777 689.808 575.335 689.808C566.418 689.808 555.845 685.738 543.62 677.59C531.4 669.447 519.751 663.633 508.686 660.138C484.075 660.138 465.495 652 452.941 635.708C439.726 618.593 433.119 597.155 433.119 571.395C433.119 552.613 436.548 536.119 443.402 521.908C450.255 507.698 459.794 497.188 472.017 490.375C482.261 484.722 494.154 481.896 507.696 481.896C530.654 481.896 548.744 489.749 561.957 505.456C575.17 521.158 581.777 542.642 581.777 569.894ZM537.425 530.756C535.773 525.273 532.722 520.537 528.261 516.55C522.478 511.394 515.46 508.821 507.202 508.821C494.648 508.821 485.729 513.889 480.442 524.026C474.661 535.161 471.772 550.951 471.772 571.395C471.772 601.142 476.892 619.841 487.133 627.482C492.417 631.474 499.273 633.467 507.696 633.467C519.751 633.467 528.467 628.564 533.834 618.759C539.205 608.954 541.886 592.998 541.886 570.893C541.886 553.778 540.399 540.395 537.425 530.756Z" fill="#1A3233" />
        <path d="M289.664 657.4V484.142H328.067L361.02 553.446C369.28 570.893 375.555 587.262 379.849 602.555C378.197 584.275 377.291 568.403 377.124 554.937L376.381 484.142H409.333V657.4H373.16L343.678 591.088C330.956 562.335 323.195 543.388 320.386 534.25C321.214 544.055 321.79 560.425 322.12 583.359L323.113 657.4H289.664Z" fill="#1A3233" />
        <path d="M165.286 657.4V484.142H263.4L263.328 512.559H199.973V552.696H249.279V581.117H200.469V627.482H265.63V657.4H165.286Z" fill="#1A3233" />
        <path d="M20.3869 657.4V483.889H78.6098C97.4412 483.889 111.562 488.046 120.978 496.355C130.394 504.664 135.101 514.971 135.101 527.266C135.101 539.07 131.219 548.792 123.458 556.433C119.494 560.259 114.207 563.252 107.6 565.41C130.394 572.389 141.79 586.931 141.79 609.037C141.79 621.834 138.075 632.555 130.64 641.196C122.383 650.835 111.068 656.069 96.6978 656.903C91.4136 657.234 84.0612 657.4 74.6455 657.4H20.3869ZM76.6289 582.111H55.0732V628.978H77.6194C84.7223 628.978 90.0913 627.653 93.7239 624.992C99.6717 620.669 102.646 613.939 102.646 604.797C102.646 593.495 98.4317 586.434 90.0064 583.607C87.0351 582.613 82.5742 582.111 76.6289 582.111ZM74.6455 513.558H54.5792V553.446H75.1419C82.4096 553.446 87.2821 552.737 89.762 551.324C92.2369 549.911 94.385 547.42 96.2012 543.848C98.0175 540.271 98.9282 536.74 98.9282 533.251C98.9282 524.776 95.625 518.957 89.0186 515.8C85.8775 514.303 81.0873 513.558 74.6455 513.558Z" fill="#1A3233" />
        <path d="M757.196 657.4V484.142H855.31L855.238 512.559H791.88V552.696H841.186V581.117H792.379V627.482H857.538V657.4H757.196Z" fill="#1A3233" />
        <path d="M602.985 604.802V486.943C621.096 484.096 629.781 495.366 638.415 513.977V598.072C638.415 608.043 639.408 614.938 641.389 618.759C645.52 626.737 653.367 630.728 664.928 630.728H664.964H665.087H665.128C676.684 630.728 684.536 626.737 688.663 618.759C690.643 614.938 691.636 608.043 691.636 598.072V513.977C700.27 495.366 708.955 484.096 727.066 486.943V604.802C727.066 616.766 725.574 625.618 722.857 631.473C713.92 650.727 694.749 660.485 665.087 660.64H664.964C635.307 660.485 616.136 650.727 607.199 631.473C604.477 625.618 602.985 616.766 602.985 604.802Z" fill="#1A3233" />
      </svg>

    </div>

    <div class="alert alert-warning" role="alert" *ngIf="coupon">
      <h4 class="alert-title">Cupom</h4>
      <div class="text-muted">Você esta se cadastrando no sistema da Benquer usando o cupom <strong>{{ coupon }}</strong></div>
    </div>

    <form class="card card-md" [formGroup]="form" (ngSubmit)="onSubmit()">

      <div *ngIf="loading" class="spinner-wrapper position-absolute w-100 h-100 d-flex justify-content-center align-items-center">
        <div class="spinner-border spinner-border-lg text-blue" role="status"></div>
      </div>

      <div class="card-body">

        <h2 class="card-title text-center mb-4">Cadastro</h2>

        <div class="row">

          <div class="col-12 mb-3">

            <label class="form-label" for="name">
              Nome completo
              <sup class="text-danger" popover="Campo obrigatório" placement="top" triggers="mouseenter:mouseleave">*</sup>
            </label>

            <input type="text" class="form-control" id="name" name="name" formControlName="name">
            <app-input-feedback [control]="form.controls.name"></app-input-feedback>

          </div>

          <div class="col-6 mb-3">

            <label class="form-label" for="cpf_cnpj">

              CPF
              <sup class="text-danger" popover="Campo obrigatório" placement="top" triggers="mouseenter:mouseleave">*</sup>

              <span class="btn-link text-decoration-none"
                popover="Utilizamos essa informação como seu identificador único para validar sua identidade como pessoa fisica"
                placement="top"
                triggers="mouseenter:mouseleave">
                ?
              </span>

            </label>

            <input type="text" class="form-control" id="cpf_cnpj" name="cpf_cnpj" formControlName="cpf_cnpj" mask="000.000.000-00">
            <app-input-feedback [control]="form.controls.cpf_cnpj"></app-input-feedback>

          </div>

          <div class="col-6 mb-3">

            <label class="form-label" for="date">

              Data de nascimento
              <sup class="text-danger" popover="Campo obrigatório" placement="top" triggers="mouseenter:mouseleave">*</sup>

              <span class="btn-link text-decoration-none"
                popover="Utilizamos essa informação para saber sua idade e fornecer uma melhor personalização das nossas funcionalidades"
                placement="top"
                triggers="mouseenter:mouseleave">
                ?
              </span>

            </label>

            <input type="text" class="form-control" id="date" name="date" formControlName="date" placeholder="01/01/1980" [bsConfig]="datePickerConfig" [bsValue]="initialDate" [maxDate]="initialDate" bsDatepicker>
            <app-input-feedback [control]="form.controls.date"></app-input-feedback>

          </div>

          <div class="col-12 mb-3">

            <label class="form-label" for="phone">

              Telefone

              <span class="btn-link text-decoration-none"
                popover="Utilizamos essa informação para enviar notificações, mensagens informativas do sistema, ou quando você solicitar suporte"
                placement="top"
                triggers="mouseenter:mouseleave">
                ?
              </span>

            </label>

            <input type="text" class="form-control" id="phone" name="phone" formControlName="phone" placeholder="(00) 0 0000-0000" mask="{{ phoneNumber.length <= 10 ? phoneMask : mobilePhoneMask }}">
            <app-input-feedback [control]="form.controls.phone"></app-input-feedback>

          </div>

        </div>

      </div>

      <div class="card-body bg-light border-0">

        <app-address-form #addressForm></app-address-form>

      </div>

      <div class="card-body border-0">

        <div class="row">

          <div class="col-12 mb-3">

            <label class="form-label" for="email">

              Endereço de e-mail
              <sup class="text-danger" popover="Campo obrigatório" placement="top" triggers="mouseenter:mouseleave">*</sup>

              <span class="btn-link text-decoration-none"
                popover="Nós utilizaremos este dado para login da sua conta e para comunicação de problemas de acesso, senhas e reportes"
                placement="top"
                triggers="mouseenter:mouseleave">
                ?
              </span>

            </label>

            <input type="email" class="form-control" id="email" name="email" formControlName="email">
            <app-input-feedback [control]="form.controls.email"></app-input-feedback>

          </div>

          <div class="col-6 mb-3">

            <label class="form-label" for="password">
              Senha
              <sup class="text-danger" popover="Campo obrigatório" placement="top" triggers="mouseenter:mouseleave">*</sup>
            </label>

            <div class="input-group input-group-flat">

              <input [attr.type]="showPassword ? 'text' : 'password'" class="form-control" id="password" name="password" formControlName="password" autocomplete="off">

              <span class="input-group-text">

                <button type="button" class="btn-link link-secondary" (click)="togglePasswordVisibility('password')" tabindex="-1">

                  <svg *ngIf="!showPassword;" xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <circle cx="12" cy="12" r="2"></circle>
                    <path d="M22 12c-2.667 4.667 -6 7 -10 7s-7.333 -2.333 -10 -7c2.667 -4.667 6 -7 10 -7s7.333 2.333 10 7"></path>
                  </svg>

                  <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <line x1="3" y1="3" x2="21" y2="21" />
                    <path d="M10.584 10.587a2 2 0 0 0 2.828 2.83" />
                    <path d="M9.363 5.365a9.466 9.466 0 0 1 2.637 -.365c4 0 7.333 2.333 10 7c-.778 1.361 -1.612 2.524 -2.503 3.488m-2.14 1.861c-1.631 1.1 -3.415 1.651 -5.357 1.651c-4 0 -7.333 -2.333 -10 -7c1.369 -2.395 2.913 -4.175 4.632 -5.341" />
                  </svg>

                </button>

              </span>

            </div>

            <app-input-feedback [control]="form.controls.password"></app-input-feedback>
            <password-strength-meter [password]="password" (strengthChange)="onPasswordStrengthChanged($event)"></password-strength-meter>

          </div>

          <div class="col-6 mb-3">

            <label class="form-label" for="password_confirmation">
              Confirmação de senha
              <sup class="text-danger" popover="Campo obrigatório" placement="top" triggers="mouseenter:mouseleave">*</sup>
            </label>

            <div class="input-group input-group-flat">

              <input [attr.type]="showConfirmPassword ? 'text' : 'password'" class="form-control" id="password_confirmation" name="password_confirmation" formControlName="password_confirmation" ngValidateEqual="password" autocomplete="off">

              <span class="input-group-text">

                <button type="button" class="btn-link link-secondary" (click)="togglePasswordVisibility('password_confirmation')" tabindex="-1">

                  <svg *ngIf="!showConfirmPassword;" xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <circle cx="12" cy="12" r="2"></circle>
                    <path d="M22 12c-2.667 4.667 -6 7 -10 7s-7.333 -2.333 -10 -7c2.667 -4.667 6 -7 10 -7s7.333 2.333 10 7"></path>
                  </svg>

                  <svg *ngIf="showConfirmPassword" xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <line x1="3" y1="3" x2="21" y2="21" />
                    <path d="M10.584 10.587a2 2 0 0 0 2.828 2.83" />
                    <path d="M9.363 5.365a9.466 9.466 0 0 1 2.637 -.365c4 0 7.333 2.333 10 7c-.778 1.361 -1.612 2.524 -2.503 3.488m-2.14 1.861c-1.631 1.1 -3.415 1.651 -5.357 1.651c-4 0 -7.333 -2.333 -10 -7c1.369 -2.395 2.913 -4.175 4.632 -5.341" />
                  </svg>

                </button>

              </span>

            </div>

            <app-input-feedback [control]="form.controls.password_confirmation"></app-input-feedback>

          </div>

          <div class="col-12">

            <label class="form-check" [ngClass]="{ 'text-danger': acceptTermsIsInvalid }">

              <input type="checkbox" class="form-check-input" id="agree_terms" name="agree_terms" formControlName="agree_terms">
              <span class="form-check-label">
                Li e aceito os <a href="https://terms.benquer.com.br/" tabindex="-1">termos de uso</a> e <a href="https://privacy.benquer.com.br/" tabindex="-1">política de privacidade</a>.
              </span>

            </label>

          </div>

          <ng-container *ngIf="hasPhoneNumber">

            <div class="col-12">

              <label class="form-check" [ngClass]="{ 'text-danger': agreeReceivePhoneMessagesIsInvalid }">

                <input type="checkbox" class="form-check-input" id="agree_receive_phone_messages" name="agree_receive_phone_messages" formControlName="agree_receive_phone_messages">
                <span class="form-check-label">
                  Aceito receber mensagem da Benquer em meu telefone, seja via SMS, WhatsApp, Telegram ou similar
                </span>

              </label>

            </div>

          </ng-container>

          <ng-container *ngIf="addressForm?.hasAddress">

            <div class="col-12">

              <label class="form-check" [ngClass]="{ 'text-danger': agreeReceiveMailMessagesIsInvalid }">

                <input type="checkbox" class="form-check-input" id="agree_receive_mail_messages" name="agree_receive_mail_messages" formControlName="agree_receive_mail_messages">

                <span class="form-check-label">
                  Aceito receber informativos da Benquer em meu endereço
                </span>

              </label>

            </div>

          </ng-container>

          <div class="form-footer">

            <button type="submit" class="btn btn-primary w-100">
              Cadastrar
            </button>

          </div>

        </div>

      </div>

    </form>

    <div class="text-center text-muted mt-3">
      <a href="https://app.benquer.com.br/" class="btn btn-link w-100" tabindex="-1">Já sou cadastrado</a>
    </div>

  </div>

</div>
